<template>
  <div class="downloadRect">
    <img class="icon" src="/appimg/icon.png"><br>
    <a :href="androidUrl"><img class="appRect" src="/appimg/android.png"></a><br>
    <a href="https://apps.apple.com/cn/app/myssi/id1249389209"><img class="appRect" src="/appimg/ios.png"></a><br>
    <img class="qrCode" src="/appimg/wxqr.png">
    <div class="record"><a href="http://beian.miit.gov.cn">粤ICP备18138118号-2</a></div>
  </div>
</template>
<script>
import { Button } from 'vant'
import request from '@/utils/request'
export default {
  components: {
    [Button.name]: Button

  },
  data() {
    return {
      androidUrl: '#'
    }
  },

  created() {
    this.init()
  },
  methods: {
    init() {
      request({
        url: '/data/getAppDownload',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.androidUrl = response.data.androidFullUrl
      })
    },
    onJump(url) {
      window.location.href = url
    }
  }
}
</script>
<style scoped>
.downloadRect{
  z-index: 1;
  background-color: #fff;
  text-align: center;
  padding-top: 1em;
  min-height: 100vh;
  margin: 0 auto;
  max-width: 600px;
}
.downloadRect img{
  padding: 0.5em 0;
}
.appRect{
  width: 50%;
}
.qrCode{
  width: 40%;
}
.icon{
  width: 60%;
}
.record{
  text-align: center;
  font-size: 0.8em;
}
</style>
